/**
 * @param {import("axios").AxiosInstance} instance
 */

export default function regions(instance) {
	return {
		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (config = {}) => {
			return instance.get(`regions`, config)
		}
	}
}
